import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import React from 'react';

import { StyledCard } from './CardStyles';

const StudyCardSkeleton: React.FC = () => (
  <StyledCard variant="outlined" editMode sx={{ cursor: 'default' }}>
    <Stack spacing={3}>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={2}>
        <Stack direction="row" spacing={2} sx={{ flex: 1, minWidth: 0 }}>
          <Skeleton variant="circular" width={50} height={50} />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Skeleton variant="text" width="42%" height={34} />
            <Skeleton variant="text" width="34%" height={22} sx={{ mt: 0.5 }} />
            <Skeleton variant="text" width="56%" height={18} sx={{ mt: 0.75 }} />
          </Box>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ pt: 0.5 }}>
          <Skeleton variant="circular" width={32} height={32} />
          <Skeleton variant="circular" width={32} height={32} />
        </Stack>
      </Stack>

      <Box sx={{ pl: { xs: 0, sm: 8 } }}>
        <Skeleton variant="text" width="80%" height={24} />
        <Skeleton variant="text" width="68%" height={24} />
      </Box>

      <Grid container spacing={2} alignItems="flex-start">
        <Grid item xs={12} sm={4}>
          <Skeleton variant="text" width="48%" height={18} />
          <Skeleton variant="text" width="32%" height={28} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Skeleton variant="text" width="48%" height={18} />
          <Skeleton variant="text" width="32%" height={28} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Skeleton variant="text" width="52%" height={18} />
          <Skeleton variant="text" width="44%" height={28} />
        </Grid>
      </Grid>
    </Stack>
  </StyledCard>
);

export default StudyCardSkeleton;
